import { Component } from '@theme/component';

class GDEquipmentCatalog extends Component {
  #controller;
  #cards = [];
  #application = 'all';

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#initialize();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #initialize() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#cards = [...this.querySelectorAll('[data-gd-equipment-card]')];
    const applications = this.querySelector('[data-gd-applications]');
    if (applications instanceof HTMLElement) applications.hidden = false;
    const submit = this.querySelector('[data-gd-sort-submit]');
    if (submit instanceof HTMLElement) submit.hidden = true;
    this.addEventListener('click', this.#onClick, { signal });
    this.addEventListener('change', this.#onChange, { signal });
  }

  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-gd-application], [data-gd-reset]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
    this.#application = button.dataset.gdApplication || 'all';
    this.#filter();
  };

  #onChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-gd-sort]')) return;
    event.target.form?.requestSubmit();
  };

  #filter() {
    let count = 0;
    for (const card of this.#cards) {
      card.hidden = this.#application !== 'all' && card.dataset.application !== this.#application;
      if (!card.hidden) count++;
    }
    for (const button of this.querySelectorAll('[data-gd-application]')) {
      button.setAttribute('aria-pressed', String(button.dataset.gdApplication === this.#application));
    }
    const status = this.querySelector('[data-gd-count]');
    if (status) status.textContent = `${count} ${count === 1 ? this.dataset.countOne : this.dataset.countMany}`;
    const empty = this.querySelector('[data-gd-empty]');
    if (empty instanceof HTMLElement) empty.hidden = count !== 0;
  }

}

if (!customElements.get('gd-equipment-catalog')) customElements.define('gd-equipment-catalog', GDEquipmentCatalog);
